<template>
  <div id="box">
    <!-- 顶部起始位置 -->
    <historyTag :historyArr="historyArr"></historyTag>
    <!-- 顶部结束位置 -->

    <div id="mainBox">
      <div v-if="isPage == 'index'" class="body">

        <div class="flex">
          <ul class="topBox">
          
            <li class="flex">
              <div style="width: 240px">
                <el-input v-model="searchVle" placeholder="请输入意见反馈"></el-input>
              </div>
            </li>

            <li class="flex" style="padding-top: 5px">
              <el-button type="success" size="small" @click="searchFn">搜索</el-button>


            </li>
          </ul>

        </div>


        <!-- 主体内容 -->
        <div>
          <el-table :data="tableData" border style="width: 100%; margin-top: 10px" @row-click="clickData">

            <!-- <el-table-column prop="id" width="100" align="center" label="ID">
            </el-table-column> -->
            <el-table-column type="index" align="center" label="头像" width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.user">
                  <img :src="scope.row.user.photo" style="width: 45px; height: 45px" alt="" srcset="" />
                </div>
              </template>
            </el-table-column>


            <el-table-column prop="nickname" align="center" label="昵称">
              <template slot-scope="scope">
                <div v-if="scope.row.user">
                 {{scope.row.user.nickName}}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="depict" align="center" label="意见反馈">
            </el-table-column>
       

            <el-table-column prop="time" align="center" label="注册时间">
            </el-table-column>



          </el-table>

          <div class="page_box">
            <el-pagination @current-change="changePage" :current-page.sync="currentPage" :page-size="pageSize"
              layout="total, prev, pager, next,jumper" :total="tableTotal">
            </el-pagination>
          </div>
        </div>
        <!-- 主体内容 -->
      </div>







    </div>
  </div>
</template>

<script>
import { delTips, returnTime } from "@/util/utils";


export default {
  components: {

  },
  data() {
    return {
      isPage: "index",

      dataList: {},

      surplusShow: 0,
      userList: "",

      // 历史记录
      historyArr: ["意见反馈"],

      //  搜索
      searchVle: "",

   

      // 数据信息
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      tableTotal: 0,

      // 用户密码
      delShow: 0, //删除提示
      delList: {},
      userPass: "",
    };
  },
  mounted() {
    this.selListFn(1);
  },
  methods: {
    // 搜索
    searchFn: function (res) {
      this.selListFn(1);
      this.currentPage = 1;
    },

    clickData() {

    },

 



    // 查询
    selListFn: function (page) {
      var obj = {
        page: page,
        size: this.pageSize,
      };

      

      if (this.searchVle) {
        obj.depict = this.searchVle;
      }

      this.$https(this.$api.api.selFeedback, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          var data = res.data.data;
          data.forEach(v => {
            v.time = v.createTime ? returnTime(new Date(v.createTime),'-','s') : "";

          });
          this.tableData = data;
          this.tableTotal = res.data.size;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
        }
      });
    },

    // 返回
    returnFn(res) {
      this.selListFn(this.currentPage);
      this.isPage = "index";
      this.historyArr.pop();
    },

    // 分页
    changePage: function (res) {
      this.selListFn(res);
    },

    // 删除
    delFn: delTips(function (index) {
      var list = this.tableData[index];

      this.$https(
        this.$api.api.delFeedback,
        {

          id: list.id,
        },
        "GET"
      ).then((res) => {
        if (res.data.code == 200) {
          this.selListFn(this.currentPage);
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }),
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;

  .body {
    margin-top: 20px;
  }

  .top_right {
    display: flex;
  }

  .topBox {
    width: 100%;
    margin-top: 10px;
    overflow: hidden;
    font-size: 15px;

    li {
      float: left;
      margin-right: 20px;
      margin-bottom: 10px;

      .el-range-editor.el-input__inner {
        width: 290px;
      }
    }

    li:last-child {
      margin-right: 0px;
    }

    span {
      margin-right: 5px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/feedback/index.vue